/* eslint-disable react/prop-types */
import Navbar from '@/components/Navbar';
import { useContext, useEffect } from 'react';
import bg from '../../assets/images/web1.jpg';
import { CabinetContext } from './context';
import Login from './Stepps/login';
import Review from './Stepps/review';
import Type from './Stepps/Type';
import Conditions from './Stepps/Conditions';
import Cabinets from './Stepps/Cabinets';
import { Steepers } from '../../components/steppers';
import Two from './Stepps/two';
import Three from './Stepps/three';
export default function Department() {
  const {
    state: { step, form }
  } = useContext(CabinetContext);

  useEffect(() => {
    const reviewElement = document.getElementById('review');
    if (reviewElement) {
      reviewElement.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [step]);

  return (
    <div className="w-screen h-screen bg-red-50 flex">
      <div className="flex-1 bg-primary  relative">
        <img className=" absolute w-full object-cover  h-full z-10" src={bg} alt="" />
      </div>
      <div id="review" className="w-[700px] bg-gray-50 h-screen flex flex-col overflow-auto">
        <Navbar />
        <div className="p-5">
          {step !== 0 && step !== 5 && (
            <div className="mx-4 p-4">
              <Steepers step={step} form={form} />
            </div>
          )}
        </div>
        <div className="flex-1 flex flex-col">
          {step === 0 && <Login />}
          {step === 1 && <Conditions />}
          {step === 2 && <Two />}
          {step === 3 && <Review />}
        </div>
      </div>
    </div>
  );
}
